function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import { Box, Pressable, Text, VStack } from 'native-base';
import { GreenTickIcon } from '../../assets';
import IconMap from '../../utils/AssestsMap';
const RadioCard = _ref => {
  let {
    icon,
    label,
    value,
    id,
    isActive,
    setActive,
    boxProps = {
      w: '50',
      h: '182'
    },
    textProps = {
      color: 'black.200'
    }
  } = _ref;
  // @ts-ignore
  const Icon = typeof icon === 'string' ? IconMap[icon] : icon;
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => setActive(value, label),
    accessibilityLabel: `tap on ${label}`,
    accessibilityRole: "button",
    testID: `radio-card-${id}`
  }, /*#__PURE__*/React.createElement(Box, _extends({}, boxProps, {
    bg: "white.700",
    shadow: "7",
    borderRadius: "md",
    justifyContent: "center",
    key: id,
    borderColor: isActive ? 'green.400' : 'grey.800',
    borderWidth: isActive ? '4' : '0',
    my: {
      md: '5',
      lg: '5'
    }
  }), !isActive ? null : /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: "2",
    right: "2",
    accessibilityLabel: `${label} selected`,
    accessibilityRole: "image",
    testID: `radio-card-green-tick-icon`
  }, /*#__PURE__*/React.createElement(GreenTickIcon, null)), /*#__PURE__*/React.createElement(VStack, {
    space: "3",
    justifyContent: "center",
    alignItems: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, null) : null, /*#__PURE__*/React.createElement(Text, _extends({
    width: 40,
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "lg",
    textAlign: "center"
  }, textProps, {
    accessibilityLabel: label,
    accessibilityRole: "text",
    testID: `radio-card-${label}`
  }), label))));
};
export default /*#__PURE__*/memo(RadioCard);
//# sourceMappingURL=index.js.map